import { useState, useEffect } from 'react';

const useLightAnimation = (speed, roadRotateZ) => {
  const [lightPosition, setLightPosition] = useState([roadRotateZ, 6, 40]);
  const [lightIntensity, setLightIntensity] = useState(1);

  useEffect(() => {
    let direction = -1;
    const duration = speed * 1340; 
    const intensityFadeDuration = speed * 1540;
    const steps = 60; 
    const stepTime = duration / steps; 
    const stepSize = 40 / steps;

    const interval = setInterval(() => {
      setLightPosition(([x, y, z]) => {
        if (z <= 0) {
          let fadeOutInterval = setInterval(() => {
            setLightIntensity((intensity) => {
              if (intensity <= 0.01) {
                clearInterval(fadeOutInterval); 

                setLightPosition([x, y, 40]);
                let fadeInInterval = setInterval(() => {
                  setLightIntensity((intensity) => {
                    if (intensity >= 1) {
                      clearInterval(fadeInInterval); 
                      return 1;
                    }
                    return intensity + 0.008; 
                  });
                }, intensityFadeDuration / 10);
              }
              return intensity - 0.01; 
            });
          }, intensityFadeDuration / 10);

          return [roadRotateZ - 4, y, z];
        }
        return [roadRotateZ - 4, y, z + stepSize * direction];
      });
    }, stepTime);

    return () => clearInterval(interval);
  }, [speed, roadRotateZ]);

  return { lightPosition, lightIntensity };
};

export default useLightAnimation;